import { createFileRoute } from '@tanstack/react-router'
import NotFoundPage from '../../containers/NotFoundPage'

// Catch-all for unknown authenticated URLs. Lives inside `_authenticated` so the
// 404 renders with the app shell (sidebar/top bar) instead of in isolation.
export const Route = createFileRoute('/_authenticated/$')({
  component: NotFoundPage
})
